import { combineReducers } from 'redux';

import UserReducer from './users/UserReducer';
import AdminsReducer from './users/AdminsReducer';
import ManagersReducer from './users/ManagersReducer';
import RestaurantsReducer from './restaurants/RestaurantsReducer';
import RestaurantReducer from './restaurants/RestaurantReducer';
import LoadingReducer from './LoadingReducer';
import MessageReducer from './MessageReducer';
import TimezoneReduces from './restaurants/TimezoneReducer';
import PosSettingsReducer from './restaurants/settings/pos/PosSettingsReducer';
import PosTypesReducer from './restaurants/settings/pos/PosTypesReducer';
import ChargeTypeMappingReducer from './restaurants/settings/pos/ChargeTypeMappingReducer';
import ChargeTypesReducer from './restaurants/settings/pos/ChargeTypesReducer';
import BrandReducer from './brands/BrandReducer';
import BrandsReducer from './brands/BrandsReducer';
import RestaurantsSummaryReducer from './restaurants/RestaurantsSummaryReducer';
import OrderTypeMappingsReducer from './restaurants/settings/pos/OrderTypeMappingsReducer';
import OrderPosTypesReducer from './restaurants/settings/pos/OrderPosTypesReducer';
import TenderTypeMappingReducer from './restaurants/settings/pos/TenderTypeMappingReducer';
import TenderPosTypesReducer from './restaurants/settings/pos/TenderPosTypesReducer';
import MenusReducer from './restaurants/posmenu/MenusReducer';
import CategoriesReducer from './restaurants/posmenu/CategoriesReducer';
import ProductsReducer from './restaurants/posmenu/ProductsReducer';
import QuestionsReducer from './restaurants/posmenu/QuestionsReducer';
import AnswersReducer from './restaurants/posmenu/AnswersReducer';
import OrdersHistoryReducer from './restaurants/orders/OrdersHistoryReducer';
import JobHistoryReducer from './jobhistory/JobHistoryReducer';
import DependsOnQuestionsReducer from './restaurants/posmenu/DependsOnQuestionsReducer';
import JobPayloadReducer from "./jobhistory/JobPayloadReducer";
import JobItemsReducer from "./jobhistory/JobItemsReducer";
import OpenigHoursReducer from "./restaurants/settings/restaurant/OpenigHoursReducer";
import TaxBandsReducer from "./restaurants/settings/restaurant/TaxBandsReducer";
import TaxSettingsReducer from "./restaurants/settings/restaurant/TaxSettingsReducer";
import GeneralServicesReducer from './restaurants/settings/service/GeneralServicesReducer';
import OrderTypesReducer from './restaurants/settings/service/OrderTypesReducer';
import DaysOffReducer from './restaurants/settings/restaurant/DaysOffReducer';
import DeliveryReducer from './restaurants/settings/service/DeliveryReducer';
import CollectionReducer from './restaurants/settings/service/CollectionReducer';
import DineInReducer from './restaurants/settings/service/DineInReducer';
import CurbsideReducer from './restaurants/settings/service/CurbsideReducer';
import TenderTypesReducer from './restaurants/settings/service/TenderTypesReducer';
import NotificationsReducer from "./NotificationsReducer";
import ImportInProgressReducer from './ImportInProgressReducer';
import PublishInProgressReducer from './PublishInProgressReducer';
import RestaurantProductsReducer from './promotions/RestaurantProductsReducer';
import PromotionsScreenReducer from './promotions/PromotionsScreenReducer';
import PromotionsSummaryReducer from './promotions/PromotionsSummaryReducer';
import PromotionPromoCodesReducer from './promotions/PromotionPromoCodesReducer';
import SubQuestionsReducer from './restaurants/posmenu/SubQuestionsReducer';
import SubAnswersReducer from './restaurants/posmenu/SubAnswersReducer';
import AllergensReducer from './restaurants/posmenu/AllergensReducer';
import DietaryInfoReducer from './restaurants/posmenu/DietaryInfoReducer'
import OrderDetailsReducer from "./restaurants/orders/OrderDetailsReducer";
import ReportsReducer from './restaurants/reports/ReportsReducer';
import LoyaltyReducer from './restaurants/loyalty/LoyaltyReducer';
import LoyaltyUsersReducer from './restaurants/loyalty/LoyaltyUsersReducer';
import LoyaltyUserCodesReducer from './restaurants/loyalty/LoyaltyUserCodesReducer';
import MenuCategoryProductReducer from './restaurants/posmenu/MenuCategoryProductReducer';
import UpsellSettingsReducer from './restaurants/upsell/UpsellSettingsReducer';
import CentralOrdersLogReducer from './central/CentralOrdersLogReducer';
import DeliveryProviderReducer from './restaurants/settings/service/DeliveryProviderReducer';
import AppNotificationReducer from './brands/AppNotificationReducer';
import InStoreSettingsReducer from './restaurants/settings/service/InStoreReducer';
import SurveyPartnerReducer from './restaurants/settings/service/SurveyPartnerReducer';
import NutrientsReducer from './restaurants/posmenu/NutrientsReducer';
import RestrictionsReducer from './systemControl/RestrictionsReducer';
import ManualActionsReducer from './systemControl/ManualActionsReducers';
import ResendOdersReducer from './systemControl/ResendOrdersReducer';
import PromotionProvidersReducer from './promotionProviders/PromotionProvidersReducer';
import DatabaseReducer from './systemControl/DatabaseReducer';
import EventTrackingReducer from './eventTracking/EventTrackingReducer';
import LanguageReducer from './LanguageReducer';
import CustomerInsightReducer from './restaurants/customerInsight/CustomerInsightReducer';
import CustomerInsightOrderTypeReducer from './restaurants/customerInsight/CustomerInsightOrderTypeReducer';
import CustomerInsightPaymentTypeReducer from './restaurants/customerInsight/CustomerInsightPaymentTypeReducer';
import CustomerInsightSourceTypeReducer from './restaurants/customerInsight/CustomerInsightSourceTypeReducer';
import CustomerInsightOrderFrequencyReducer from './restaurants/customerInsight/CustomerInsightOrderFrequencyReducer';
import CustomerInsightDailyOrderFrequencyReducer from './restaurants/customerInsight/CustomerInsightDailyOrderFrequencyReducer';
import CustomerInsightProductSummaryReducer from './restaurants/customerInsight/CustomerInsightProductSummaryReducer';
import CustomerInsightPromotionNamesReducer from './restaurants/customerInsight/CustomerInsightPromotionNamesReducer';
import CustomerInsightPromotionSummaryReducer from './restaurants/customerInsight/CustomerInsightPromotionSummaryReducer';
import CustomerInsightPromotionSearchReducer from './restaurants/customerInsight/CustomerInsightPromotionSearchReducer';
import CustomerInsightRefundReducer from './restaurants/customerInsight/CustomerInsightRefundReducer';
import CustomerInsightOrderSearchReducer from './restaurants/customerInsight/CustomerInsightOrderSearchReducer';
import RestaurantInsightReducer from './restaurants/restaurantInsight/RestaurantInsightReducer';
import ProductCopyReducer from './restaurants/posmenu/ProductCopyReducer';
import BillingDashboardReducer from './billingDashboard/BillingDashboardReducer';
import GiftCardProviderReducer from './restaurants/settings/service/GiftCardProviderReducer';
import MarketingAutomationsReducer from './marketingAutomations/MarketingAutomationsReducer';
import SelectedMarketingAutomationReducer from './marketingAutomations/SelectedMarketingAutomationReducer';
import TriggerImagesReducer from './marketingAutomations/TriggerImagesReducer';
import InitialAudienceReducer from './marketingAutomations/InitialAudienceReducer';
import CustomerInsightNotificationReducer from './restaurants/customerInsight/CustomerInsightNotificationReducer';
import LoyaltyErrorResponseReducer from './restaurants/loyalty/LoyaltyErrorResponseReducer';
import PromotionsSearchReducer from './promotions/PromotionsSearchReducer';
import CustomersReducer from './customers/CustomersReducer';

const rootReducer = combineReducers({
	user: UserReducer,
	notifications: NotificationsReducer,
	admins: AdminsReducer,
	manager: ManagersReducer,
	brand: BrandReducer,
	brands: BrandsReducer,
	restaurants: RestaurantsReducer,
	restaurant: RestaurantReducer,
	daysOff: DaysOffReducer,
	restaurantsSummary: RestaurantsSummaryReducer,
	loading: LoadingReducer,
	message: MessageReducer,
	timezones: TimezoneReduces,
	posTypes: PosTypesReducer,
	posSettings: PosSettingsReducer,
	restaurantOpeningHours: OpenigHoursReducer,
	taxBands: TaxBandsReducer,
	taxSettings: TaxSettingsReducer,
	orderTypeMappings: OrderTypeMappingsReducer,
	orderPosTypes: OrderPosTypesReducer,
	tenderTypeMappings: TenderTypeMappingReducer,
	tenderPosTypes: TenderPosTypesReducer,
	chargeTypeMappings: ChargeTypeMappingReducer,
	chargePosTypes: ChargeTypesReducer,
	serviceSettingsGeneral: GeneralServicesReducer,
	orderTypes: OrderTypesReducer,
	tenderTypes: TenderTypesReducer,
	deliverySettings: DeliveryReducer,
	collectionSettings: CollectionReducer,
	dineInSettings: DineInReducer,
	curbsideSettings: CurbsideReducer,
	inStoreSettings: InStoreSettingsReducer,
	menus: MenusReducer,
	categories: CategoriesReducer,
	products: ProductsReducer,
	questions: QuestionsReducer,
	answers: AnswersReducer,
	orders: OrdersHistoryReducer,
	jobHistory: JobHistoryReducer,
	jobPayload: JobPayloadReducer,
	jobItems: JobItemsReducer,
	dependsOnQuestions: DependsOnQuestionsReducer,
	importInProgress: ImportInProgressReducer,
	publishInProgress: PublishInProgressReducer,
	restaurantProducts: RestaurantProductsReducer,
	promotions: PromotionsScreenReducer,
	promotionsSummary: PromotionsSummaryReducer,
	promoCodes: PromotionPromoCodesReducer,
	subQuestions: SubQuestionsReducer,
	subAnswers: SubAnswersReducer,
	allergens: AllergensReducer,
	dietaryInfo: DietaryInfoReducer,
	оrderDetails: OrderDetailsReducer,
	loyalty: LoyaltyReducer,
	loyaltyUsers: LoyaltyUsersReducer,
	loyaltyUserCodes: LoyaltyUserCodesReducer,
	loadedReports: ReportsReducer,
	menusCategoriesProducts: MenuCategoryProductReducer,
	upsellSettings: UpsellSettingsReducer,
	ordersLog: CentralOrdersLogReducer,
	deliveryProvider: DeliveryProviderReducer,
	appNotifications: AppNotificationReducer,
	surveyPartner: SurveyPartnerReducer,
	nutrients: NutrientsReducer,
	restrictions: RestrictionsReducer,
	resendOrders: ResendOdersReducer,
	promotionProviders: PromotionProvidersReducer,
	databaseData: DatabaseReducer,
	cronJobByTime: ManualActionsReducer,
	eventTrackingLog: EventTrackingReducer,
	language: LanguageReducer,
	customerInsight: CustomerInsightReducer,
	customerInsightOrderTypes: CustomerInsightOrderTypeReducer,
	customerInsightPaymentTypes: CustomerInsightPaymentTypeReducer,
	customerInsightSourceTypes: CustomerInsightSourceTypeReducer,
	customerInsightOrderFrequency: CustomerInsightOrderFrequencyReducer,
	customerInsightDailyOrderFrequency: CustomerInsightDailyOrderFrequencyReducer,
	customerInsightProductSummary: CustomerInsightProductSummaryReducer,
	customerInsightPromotionNames: CustomerInsightPromotionNamesReducer,
	customerInsightPromotionSummary: CustomerInsightPromotionSummaryReducer,
	customerInsightPromotionSearch: CustomerInsightPromotionSearchReducer,
	customerInsightRefundSearch: CustomerInsightRefundReducer,
	customerInsightOrderSearch: CustomerInsightOrderSearchReducer,
	customerInsightNotificationSearch: CustomerInsightNotificationReducer,
	restaurantInsight: RestaurantInsightReducer,
	productCopy: ProductCopyReducer,
	billingDashboard: BillingDashboardReducer,
	giftCardProvider: GiftCardProviderReducer,
	marketingAutomations: MarketingAutomationsReducer,
	selectedMarketingAutomation: SelectedMarketingAutomationReducer,
	triggerImages: TriggerImagesReducer,
	initialAudience: InitialAudienceReducer,
	loyaltyErrorResponse: LoyaltyErrorResponseReducer,
	promotionsSearchResponse: PromotionsSearchReducer,
	customersInfo: CustomersReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js